import { axiosInstance } from '../../../api';
const BASE_PATH = '/hiring_pipeline';

//Create CV Review Step API Call
export let addCVReviewStep = async (reviewers, pipelineID, stageName, description, numReviewers, score) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_cv_review_step', {
            reviewers: reviewers,
            pipeline: pipelineID,
            stage_name: stageName,
            description: description,
            number_of_reviewers_per_cv: numReviewers,
            pass_threshold_score: score
        })
        return value;
    } catch (error) {
        return error
    }
}

//Create Interview Step API Call
export let addInterviewStep = async (pipelineID, stageName, description, score, interviewGuideline) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_interview_step', {
            pipeline: pipelineID,
            stage_name: stageName,
            description: description,
            pass_threshold_score: score,
            interview_guidelines_to_candidate: interviewGuideline,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Create external Step API Call
export let addExternalAssessmentStep = async (pipelineID, stageName, description, reviewers, score, assessment_body, assessment_exp_date) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_external_assessment_step', {
            pipeline: pipelineID,
            stage_name: stageName,
            description: description,
            reviewers: reviewers,
            pass_threshold_score: score,
            assessment: assessment_body,
            assessment_expire_in: assessment_exp_date


        })
        return value;
    } catch (error) {
        return error
    }
}

//Create external Step API Call
export let addCVFilterStep = async (pipelineID, stageName, keywordCount, keywords) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_automated_cv_filter_step', {
            pipeline: pipelineID,
            stage_name: stageName,
            required_minimum_keyword_count: keywordCount,
            keywords_to_scan: keywords
        })
        return value;
    } catch (error) {
        return error
    }
}

//add quiz stage API call
export let addQuizStep = async (pipelineID, stageName, score, quiz_template_ID, quiz_exp_date) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_quiz_step', {
            pipeline: pipelineID,
            stage_name: stageName,
            pass_threshold_score: score,
            quiz_template: quiz_template_ID,
            is_custom_quiz_template: false,
            quiz_expire_in: quiz_exp_date

        })
        return value
    } catch (error) {
        return error
    }
}

//Create reference check Step API Call
export let addReferenceCheckStep = async (pipelineID, stageName, description, reviewers) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_reference_check_step', {
            pipeline: pipelineID,
            stage_name: stageName,
            description: description,
            reviewers: reviewers,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Create cutomized assessment Step API Call
export let addCustomEvaluationStep = async (pipelineID, stageName, description, reviewers, score, evaluationDescription) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_custom_evaluation_step', {
            pipeline: pipelineID,
            stage_name: stageName,
            description: description,
            reviewers: reviewers, 
            pass_threshold_score: score,
            custom_evaluation_description: evaluationDescription,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Create One Way Interview Step API Call
export let addOneWayInterviewStep = async (pipelineID, stageName, description, reviewers, score, interview_exp_in, interview_template_ID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/add_one_way_interview_step', {
            pipeline: pipelineID,
            stage_name: stageName,
            description: description,
            reviewers: reviewers, 
            pass_threshold_score: score,
            expire_in: interview_exp_in,
            one_way_interview_template: interview_template_ID,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Delete pipeline Step API Call
export let deletePipelineStep = async (stepID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/delete_pipeline_step', {
            pipeline_step_id: stepID
        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit Interview Step API Call
export let editPipelineStepInterview = async (stepID, desc, score, interviewGuideline) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_pipeline_interview_step', {
            pipeline_step_id: stepID,
            description: desc,
            pass_threshold_score: score,
            interview_guidelines_to_candidate: interviewGuideline,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit CV Review Step API Call
export let editPipelineStepCVReview = async (stepID, desc, reviewers, noReviewers, score) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_pipeline_cv_review_step', {
            pipeline_step_id: stepID,
            description: desc,
            reviewers: reviewers,
            number_of_reviewers_per_cv: noReviewers,
            pass_threshold_score: score
        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit External Assessment Step API Call
export let editExternalAssessmentStep = async (stepID, desc, reviewers, score, assessment, expireDate) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_pipeline_external_assessment_step', {
            pipeline_step_id: stepID,
            description: desc,
            reviewers: reviewers,
            pass_threshold_score: score,
            assessment: assessment,
            assessment_expire_in: expireDate

        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit CV Filter Step API Call
export let editCVFilterStep = async (stepID, keywodCount, keywords) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_automated_cv_filter_step', {
            pipeline_step_id: stepID,
            required_minimum_keyword_count: keywodCount,
            keywords_to_scan: keywords,
        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit Quiz Step API Call
export let editQuizStep = async (pipelineID, score, quiz_template_ID, quiz_exp_date) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_quiz_step', {
            pipeline_step_id: pipelineID,
            pass_threshold_score: score,
            quiz_template: quiz_template_ID,
            is_custom_quiz_template: false,
            quiz_expire_in: quiz_exp_date
        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit Reference Check Step API Call
export let editReferenceCheckStep = async (stepID, desc, reviewers) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_reference_check_step', {
            pipeline_step_id: stepID,
            description: desc,
            reviewers: reviewers,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit Custom Evaluation Step API Call
export let editCustomEvaluationStep = async (stepID, desc, score, reviewers, evaluationDescription) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_custom_evaluation_step', {
            pipeline_step_id: stepID,
            description: desc,
            pass_threshold_score: score,
            reviewers: reviewers,
            custom_evaluation_description: evaluationDescription,

        })
        return value;
    } catch (error) {
        return error
    }
}

//Edit One Way Interview Step API Call
export let editOneWayInterviewStep = async (stepID, desc, score, reviewers, interview_exp_in, interview_template_ID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/edit_one_way_interview_step', {
            pipeline_step_id: stepID,
            description: desc,
            pass_threshold_score: score,
            reviewers: reviewers,
            expire_in: interview_exp_in,
            one_way_interview_template: interview_template_ID,

        })
        return value;
    } catch (error) {
        return error
    }
}

//enable pstep rejection email 
export let enableStepRejectionEmail = async (stepID,isEnabled) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/enable_step_rejection_email', {
            pipeline_step_id: stepID,
            is_reject_email_enable: isEnabled,
        })
        return value
    } catch (error) {
        return error
    }
}



